// Shared constants for notification acknowledgment.
// Types that REQUIRE explicit "Confirmar visto" (acuse) from agent/TM.
export const ACK_REQUIRED_TYPES = new Set([
  'price_change_request',
  'price_change_approved',
  'price_change_rejected',
  'price_push_24h',
  'price_push_2h',
  'price_push_eff',
  'price_pending',
]);
